import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../Common/ChartsDynamicColor"
import { startCase } from "lodash"
import PropTypes from "prop-types"
import { getIndividualOrderStatusCount } from "http/dashboard"
import NoDataChart from "pages/Dashboards/NoDataChart"

const OrderStatus = ({ dataColors, userType, totalOrders }) => {
  const apexsalesAnalyticsChartColors = getChartColorsArray(dataColors)
  const [dealStatusData, setDealStatusData] = useState({})
  const [showStatus, setShowStatus] = useState(true)
  useEffect(() => {
    getIndividualOrderStatusCount()
      .then(responseFromApi => {
        let status = {}
        if (responseFromApi.status && responseFromApi?.data?.length>0) {
          responseFromApi.data.forEach(item => {
            status[item.orderStatus] = item.count
          })
          setDealStatusData(status)
        } else {
          setShowStatus(false)
          setDealStatusData({})
        }
      })
      .catch(error => { })
  }, [])


  const labels = Object.keys(dealStatusData).filter(
    key => key !== "totalOrders"
  )

  const values = labels
    .map(label => dealStatusData[label])
    .filter(value => value !== dealStatusData.totalOrders)

  const series = values

  const options = {
    chart:{
      width:'400px',
      height:'352px'
    },
    labels: labels.map(i => startCase(i)),
    colors: apexsalesAnalyticsChartColors,
    legend: { show: false },
    dataLabels: {
      enabled: true,
      formatter: function ({ seriesIndex, w }) {
        return w?.globals?.series[seriesIndex]
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,

            value: {
              show: false,
            },
          },
          size: "63%",
        },
      },
    },
    tooltip: {
      enabled: true,
      y: {
        show: true,
        formatter: value => {
          return `${value}`
        },
      },
    },
    annotations: {
      position: "center",
      yaxis: [
        {
          y: 0,
          y2: 1,
          label: {
            text: "Deal Status",
            style: {
              fontSize: "20px",
              color: "#333",
              background: "transparent",
            },
          },
        },
      ],
    },
    responsive:[
      {
        breakpoint:1125,
        options:{
          chart:{
            width:'350px',
            height:'350px'
          }
        }
      }
    ]
  }

  return (
    <Card className="h-100">
      {showStatus ? <CardBody>
        <h4 className="card-title mb-2">
          {userType === "admin"
            ? "Total Order Request"
            : "Total order summary"}
        </h4>
        <div className="d-flex align-items-center  flex-column flex-md-row">
          <div style={{position:'relative'}}>
          <div id="donut-chart-deal-status">
            {values?.length > 0 ? (
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                height={352}
                width={400}
                className="apex-charts"
               
              />
            ) : (
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "20px",
                  color: "#ccc",
                  height: "270px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h5> No data available</h5>
              </div>
            )}
          </div>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <div className="d-flex flex-column justify-content-center align-items-center">
            <span style={{ fontSize: "20px" }}>
              {totalOrders}
            </span>
            <span style={{ fontSize: "14px" }}>Total Orders</span>
            </div>
          </div>
          </div>
         
          {/* <div
            style={{
              position: "absolute",
              top: "45%",
              left: "35%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <span style={{ fontSize: "20px" }}>
              {totalOrders}
            </span>
          </div> */}
          {/* {values?.length > 0 && (
            <div

            >
              <span style={{ fontSize: "14px" }}>Total Orders</span>
            </div>
          )} */}
                  <Row>
          {labels.map((label, index) => {
            return (
              <Col  className="col-3  col-md-12"
                key={label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <i
                  style={{ color: apexsalesAnalyticsChartColors[index] }}
                  className={`mdi mdi-circle ${apexsalesAnalyticsChartColors[index]} me-1`}
                />
                <p
                  className="mb-2 mt-1 text-truncate"
                  title={label}
                  style={{
                    width: "200px",
                    textAlign: "left",
                    fontSize: "14px",
                  }}
                >
                  {startCase(label)}
                </p>
              </Col>
            )
          })}
        </Row>
        </div>

      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No order requests are available at the moment" />
      }
    </Card>
  )
}

OrderStatus.propTypes = {
  dataColors: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired,
  totalOrders: PropTypes.number.isRequired
}

export default OrderStatus
